import { render, staticRenderFns } from "./GroupTypeEditModal.vue?vue&type=template&id=13b486bc&"
import script from "./GroupTypeEditModal.vue?vue&type=script&lang=js&"
export * from "./GroupTypeEditModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupTypeEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports